import { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'

// const agronomistFetchEndpoint = "http://localhost:4000";
const agronomistFetchEndpoint = "https://geolocation-495656309447.us-central1.run.app";

const App = () => {

    const [searchAddress, setSearchAddress] = useState("");
    const [agronomyEmployees, setAgronomyEmployees] = useState([]);
    const [localTeam, setLocalTeam] = useState([]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        const agronomistFetch = await fetch(agronomistFetchEndpoint + "/getPeople", {
            method: 'GET', body: JSON.stringify(),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const agronomistText = await agronomistFetch.json();
        setAgronomyEmployees(agronomistText);
    }

    const handleUpdateAddress = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setSearchAddress(value);
    }

    const handleKeyDown = (e) => {
        preventMinus(e);
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch(e)
        }
    }

    const preventMinus = (e) => {
        const char = e.key;
        const allowedControlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
        if (allowedControlKeys.includes(char)) {
            return; // allow these keys
        }

        const isLetter = char.length === 1 && ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z'));
        const isNumber = char >= '0' && char <= '9';
        const isAllowedSymbol = char === '.' || char === ',' || char === ' ' || char === "'";

        if (!isLetter && !isNumber && !isAllowedSymbol) {
            e.preventDefault();
        }
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        if (searchAddress !== "") {
            setLoading(true);
            const localTeamFetch = await fetch(agronomistFetchEndpoint + "/findNearest", {
                method: 'POST', body: JSON.stringify({ address: searchAddress, people: agronomyEmployees }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const localTeamText = await localTeamFetch.json();
            if (localTeamText && localTeamText.message) {
                setLocalTeam([{
                    jobTitle: "Support",
                    FirstName_VC: "Contact",
                    LastName_VC: "Support",
                    Email_VC: "support@servitech.com",
                    CellPhone_VC: "620-801-4166",
                    latitude: "0",
                    longitude: "0"
                }])
            } else {
                setLocalTeam(localTeamText);
            }
            console.log("Search finished!")
            setLoading(false);
        }
    }

    const getExactLocation = async () => {
        try {
            let location;
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log("Latitude:", position.coords.latitude);
                    console.log("Longitude:", position.coords.longitude);
                    location = { latitude: position.coords.latitude, longitude: position.coords.longitude }
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
            await new Promise(resolve => setTimeout(resolve, 1000));
            return location;
        } catch (err) {
            console.error("Geolocation is not supported by this browser.");
        }
    };

    const handleSearchByExactLocation = async (e) => {
        e.preventDefault();
        setLoading(true)
        const coordinates = await getExactLocation();
        // console.log(coordinates)
        if (coordinates) {
            const localTeamFetch = await fetch(agronomistFetchEndpoint + "/findNearest", {
                method: 'POST', body: JSON.stringify({ address: searchAddress, people: agronomyEmployees, latitude: coordinates.latitude, longitude: coordinates.longitude }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const localTeamText = await localTeamFetch.json();
            if (localTeamText?.message) {
                setLocalTeam([{
                    jobTitle: "Support",
                    FirstName_VC: "Contact",
                    LastName_VC: "Support",
                    Email_VC: "support@servitech.com",
                    CellPhone_VC: "620-801-4166",
                    latitude: "0",
                    longitude: "0"
                }])
            } else {
                setLocalTeam(localTeamText);
            }
            console.log("Search finished!")
        } else {
            console.log("Unable to find coordinates via browser.")
        }
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <>
            <div className='geolocation'>
                <Row style={{ marginBottom: "24px" }}>
                    <Col xs={12} s={8} md={8} lg={6} xl={5}>
                        <Form>
                            <Form.Control onKeyDown={(e) => handleKeyDown(e)} className='address-input' type="text" placeholder="Enter Address, City/State, or ZIP Code" title="Enter Location" onChange={(e) => handleUpdateAddress(e)} />
                        </Form>
                    </Col>
                </Row>
                <Row style={{ marginBottom: "48px" }}>
                    <Col xs={12} s={8} md={8} lg={6} xl={5} >
                        <div className="d-flex justify-content-between w-100">
                            {!loading &&
                                <Button className='search-button' disabled={!searchAddress.length} onClick={(e) => handleSearch(e)}>
                                    Search
                                </Button>
                            }
                            {loading &&
                                <Button className='search-button' onClick={(e) => e.preventDefault()}>
                                    <Spinner style={{ height: "8pt", width: "8pt" }} animation="border" />
                                </Button>
                            }
                            {!loading &&
                                    <Button className='exact-location-button' onClick={(e) => handleSearchByExactLocation(e)}>
                                        Use Device Location
                                    </Button>
                            }
                            {loading &&
                                <Button className='exact-location-button' onClick={(e) => e.preventDefault()}>
                                    <Spinner style={{ height: "8pt", width: "8pt" }} animation="border" />
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>
                <Row>
                    {localTeam && localTeam.length > 0 && localTeam.map((item, index) =>
                        <Col style={{ marginBottom: "25px" }} xs={12} s={12} md={4} lg={4} xl={3}>
                            <div className='team-div'>
                                <p className='full-name'>
                                    <b>{item.FirstName_VC} {item.LastName_VC}</b>
                                </p>
                                <p className='job-title'>
                                    {item.jobTitle}
                                </p>
                                <p className='email'>
                                    <a
                                        className='link'
                                        href={`mailto:${item.Email_VC}`}
                                        target="_blank"
                                        rel="nofollow noreferrer"
                                        title="Send Email"
                                    >
                                        {item.Email_VC}
                                    </a>
                                </p>
                                <p className='cell-phone'>
                                    <a
                                        className='link'
                                        href={`tel:+${item.CellPhone_VC}`}
                                        target="_blank"
                                        rel="nofollow noreferrer"
                                        title="Make Call"
                                    >
                                        {item.CellPhone_VC}
                                    </a>
                                </p>
                            </div>
                        </Col>
                    )}
                </Row>
            </div>
        </>
    )
}
export default App;